<template>
    <div class="grid-content">
        <div class="grid-item grid-item-half grid-item-break-half">
            <r-input
                label="SendGrid API Key"
                v-model="cred.apiKey"
                password
                :validate="$v.cred.apiKey"
                help-text="Your SendGrid API Key."/>
        </div>
    </div>
</template>

<script>
    import {required} from 'vuelidate/lib/validators';
    import BaseCredentials from './base-credentials';

    export default {
        name: 'send-grid',
        extends: BaseCredentials,
        validations: {
            cred: {
                apiKey: {required},
            },
        },
        methods: {
            getValidationAggregate() {
                return {
                    name: 'sendgrid',
                    beforeValidation: () => this.isActiveType && this.$v.$touch(),
                    rules: () => (this.isActiveType ? [
                        {
                            name: `The SendGrid API key is required.`,
                            delegate: () => this.$v.cred.apiKey.$error,
                        },
                    ] : []),
                };
            },
        },
    };
</script>

<style scoped>

</style>
